import React from 'react';
import { Link } from 'react-router-dom';

function PrevButton(props) {
    if (props.match.params.questionIndex > 0)
        return <Link id="prevButton" to={'/assignment/' + props.match.params.code + '/' + (props.match.params.questionIndex - 1) + '/' + props.match.params.totalNumberOfQuestions} className="btn btn-primary btn-lg">Previous</Link>
    return null;
}

export default PrevButton;